import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import LoadingSpinner from './components/LoadingSpinner'
import ProtectedRoute from './components/ProtectedRoute'
import HelpLayout from './pages/common/Help/HelpLayout'

const HelpHome = lazy(() => import('./pages/common/Help/HelpHome'))
const HelpArticle = lazy(() => import('./pages/common/Help/HelpArticle'))
const HelpSearch = lazy(() => import('./pages/common/Help/HelpSearch'))

const TicketingLayout = lazy(() => import('./pages/common/Tickets/TicketingLayout'))
const TicketList = lazy(() => import('./pages/common/Tickets/TicketList'))
const TicketSubmit = lazy(() => import('./pages/common/Tickets/TicketSubmit'))
const TicketDetail = lazy(() => import('./pages/common/Tickets/TicketDetail'))
const SupportDashboard = lazy(() => import('./pages/common/Tickets/SupportDashboard'))
const TicketAuditActivity = lazy(() => import('./pages/common/Tickets/TicketAuditActivity'))
const ConfigurationItems = lazy(() => import('./pages/common/Tickets/ConfigurationItems'))
const GroupManagement = lazy(() => import('./pages/common/Tickets/GroupManagement'))
const KnowledgeCreate = lazy(() => import('./pages/common/Tickets/KnowledgeCreate'))
const KnowledgeList = lazy(() => import('./pages/common/Tickets/KnowledgeList'))
const KnowledgeBaseCreate = lazy(() => import('./pages/common/Tickets/KnowledgeBaseCreate'))
const KnowledgeBaseList = lazy(() => import('./pages/common/Tickets/KnowledgeBaseList'))
const AppDashboard = lazy(() => import('./pages/common/Tickets/AppDashboard'))
const ConfigDashboard = lazy(() => import('./pages/common/Tickets/ConfigDashboard'))
const GroupDashboard = lazy(() => import('./pages/common/Tickets/GroupDashboard'))
const UserDashboard = lazy(() => import('./pages/common/Tickets/UserDashboard'))
const ChangeDashboard = lazy(() => import('./pages/common/Tickets/ChangeDashboard'))
const ClientDashboard = lazy(() => import('./pages/common/Tickets/ClientDashboard'))
const DashboardPermissions = lazy(() => import('./pages/common/Tickets/DashboardPermissions'))
const SlaConfig = lazy(() => import('./pages/common/Tickets/SlaConfig'))

const LoginPage = lazy(() => import('./pages/common/LoginPage'))

function App() {
  return (
    <>
      <Suspense fallback={<LoadingSpinner />}><Routes>
        <Route path="/login" element={<LoginPage />} />
        
        <Route path="/help" element={
          <ProtectedRoute>
            <HelpLayout />
          </ProtectedRoute>
        }>
          <Route index element={<HelpHome />} />
          <Route path="search" element={<HelpSearch />} />
          <Route path=":slug" element={<HelpArticle />} />
        </Route>

        <Route
          path="/tickets"
          element={
            <ProtectedRoute>
              <TicketingLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="my" element={<TicketList />} />
          <Route path="dashboard" element={<SupportDashboard />} />
          <Route path="support" element={<SupportDashboard />} />
          <Route path="audit" element={<TicketAuditActivity />} />
          <Route path="configuration-items" element={<ConfigurationItems />} />
          <Route path="group-management" element={<GroupManagement />} />
          <Route path="knowledge" element={<KnowledgeList />} />
          <Route path="knowledge/new" element={<KnowledgeCreate />} />
          <Route path="knowledge/:editId/edit" element={<KnowledgeCreate />} />
          <Route path="knowledge/view/:slug" element={<HelpArticle />} />
          <Route path="knowledge-base" element={<KnowledgeBaseList />} />
          <Route path="knowledge-base/new" element={<KnowledgeBaseCreate />} />
          <Route path="knowledge-base/:kbId" element={<KnowledgeBaseCreate />} />
          <Route path="app-dashboard" element={<AppDashboard />} />
          <Route path="config-dashboard" element={<ConfigDashboard />} />
          <Route path="group-dashboard" element={<GroupDashboard />} />
          <Route path="user-dashboard" element={<UserDashboard />} />
          <Route path="change-dashboard" element={<ChangeDashboard />} />
          <Route path="client-dashboard" element={<ClientDashboard />} />
          <Route path="dashboard-permissions" element={<DashboardPermissions />} />
          <Route path="sla-config" element={<SlaConfig />} />
          <Route path="new" element={<TicketSubmit />} />
          <Route path=":id" element={<TicketDetail />} />
        </Route>

        <Route path="/" element={
          <ProtectedRoute>
            <Navigate to="/tickets/dashboard" replace />
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes></Suspense>
    </>
  )
}

export default App
